module.exports = __webpack_public_path__ + "static/special-groups-3.c8001c04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/special-groups-3.jpg
// module id = 534
// module chunks = 96071698590629